import React, { useContext, useEffect } from 'react'

import { AuthenticationContext } from 'app/Contexts/AuthenticationProvider'
import { useFileUpload } from 'app/api/useFileUpload'
import { API_BASE_URL, endpoints } from 'app/api/endpoints'
import { DocumentUploadInput, DocumentUploadResponse } from 'EstraSuppliers'
import { Button } from 'app/components/ui/Button'
import { FormFeedback } from 'app/components/ui/form/FormFeedback'
import { Text } from 'app/components/ui/Text'
import { themeEstra } from 'app/styles/themeEstra'
import { InputFile } from 'app/components/ui/form/InputFile'
import { Label } from 'app/components/ui/form/Label'
import styled from 'styled-components'
import { validateInputPdfFile } from 'app/utils/file'

const apiUploadURL = `${API_BASE_URL}/${endpoints.uploadFile}`

interface Props {
  onSuccessUpload?: () => void
  isInModal?: boolean
}

export const InputHolderDocument: React.FC<Props> = ({
  onSuccessUpload,
  isInModal,
}) => {
  const authCtx = useContext(AuthenticationContext)
  const [idCardFile, setIdCardFile] = React.useState<File | null>()
  const {
    uploadFile,
    uploadIsLoading,
    uploadSuccess,
    uploadError,
  } = useFileUpload<DocumentUploadInput, DocumentUploadResponse>(apiUploadURL)

  // on upload success refetch actor
  useEffect(() => {
    if (uploadSuccess && uploadSuccess.identity_document_url && authCtx) {
      authCtx.refetchActor()
      if (onSuccessUpload) {
        onSuccessUpload()
      }
    }
  }, [uploadSuccess?.identity_document_url])

  const inputFileName = 'documentHolderInput'

  return (
    <form
      onSubmit={e => {
        e.preventDefault()
        if (idCardFile && idCardFile.name && authCtx) {
          uploadFile(
            {
              file: idCardFile,
              type: 'identity_document',
            },
            {
              limitInMb: 10,
            }
          )
        }
      }}
    >
      <InputGroup>
        <Label
          color={themeEstra.color.primari.neroEstra}
          htmlFor={inputFileName}
        >
          Carica il documento di identità del titolare
        </Label>
        <InputFile
          name={inputFileName}
          accept='image/png, image/jpeg, image/jpg, application/pdf'
          selectedFileName={idCardFile?.name}
          onChange={e => {
            const { file, isValid } = validateInputPdfFile(e)
            if (file && isValid) {
              setIdCardFile(file)
            }
          }}
        />
        <Text
          variant='s12'
          color={themeEstra.color.primari.grigioEstra}
          mt={0.5}
          isItalic
        >
          Formato immagine o PDF, dimensione massima 10 MB
        </Text>
        {uploadError ? (
          <FormFeedback variant='error'>{uploadError}</FormFeedback>
        ) : null}
      </InputGroup>

      {idCardFile ? (
        <ButtonWrapper isInModal={isInModal}>
          <Button
            size='lg'
            disabled={
              uploadIsLoading ||
              Boolean(uploadSuccess && uploadSuccess.identity_document_url)
            }
          >
            {uploadIsLoading ? 'CARICAMENTO...' : 'SALVA'}
          </Button>
        </ButtonWrapper>
      ) : null}
    </form>
  )
}

const InputGroup = styled.div`
  margin-bottom: 2rem;

  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
`

const ButtonWrapper = styled.div<{ isInModal?: boolean }>`
  display: flex;
  justify-content: ${({ isInModal }) => (isInModal ? 'flex-end' : 'center')};
`
